<template>
  <div class="lottery" :class="cssType">
    <div class="lottery-title" :class="locale"></div>
    <div class="lottery-desc">
      <div class="p" v-for="(item, index) in $t('cny.lottery.desc').split('\n')" :key="index">{{ item }}</div>
    </div>
    <div class="lottery-times">
      <div class="p" v-for="(item, index) in $t('cny.lottery.times').split('\n')" :key="index">{{ item }}</div>
    </div>
    <div class="operate">
      <CnyButton type="yellow" @click="goRecharge">{{ $t('cny.goRecharge') }}</CnyButton>
      <CnyButton type="red" @click="handleShowRecord">{{ $t('cny.record') }}</CnyButton>
    </div>
    <div class="lottery-wheel-wrapper">
      <Wheel ref="wheelRef" />
    </div>
    <div class="remaining-times" :class="locale">
      {{ $t('cny.remainingTimes') }}：{{ state.remainingTimes }}
      <div class="skip-animation" @click="state.skipAnimation = !state.skipAnimation">
        <div class="checkbox">
          <div class="checkbox-inner" :class="{ 'checked': state.skipAnimation }"></div>
        </div>
        {{ $t('cny.skipAnimation') }}
      </div>
    </div>
    <div class="lottery-operation">
      <CnyButton type="yellow" :disabled="store.state.cpUserInfo.token && state.remainingTimes <= 0" @click="handleLotteryOnce">{{ $t('cny.lotteryOnce') }}</CnyButton>
      <CnyButton type="white" :disabled="store.state.cpUserInfo.token && state.remainingTimes <= 0" @click="handleLotteryOneKey">{{ $t('cny.lotteryOneKey') }}</CnyButton>
    </div>
  </div>
</template>
<script setup>
import { reactive, ref, inject, computed } from 'vue'
import Wheel from './components/wheel'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import CnyButton from '../CnyButton'
import { useStore } from 'vuex'
import { toastService } from '@/utils/toastService'
import CnyActApi from '@/config/cnyActApi'
const store = useStore()
const globalConfig = inject('globalConfig')
const toggleLotteryRecordDialog = inject('toggleLotteryRecordDialog')
const { locale, t } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const wheelRef = ref(null)
const payUrl = computed(() => {
  return process.env.VUE_APP_HISTORY_URL + locale.value
})
const state = reactive({
  remainingTimes: computed(() => globalConfig.totalLotteryCount - globalConfig.usedLotteryCount),
  skipAnimation: false,
})
const goRecharge = () => {
  window.open(payUrl.value, '_blank')
}
const handleLotteryOnce = () => {
  if (!store.state.cpUserInfo.token) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  if (state.remainingTimes <= 0) return
  wheelRef.value.doLottery(state.skipAnimation)
}
const handleLotteryOneKey = () => {
  if (!store.state.cpUserInfo.token) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  if (state.remainingTimes <= 0) return
  wheelRef.value.doLotteryOneKey(state.skipAnimation)
}

const getLotteryRecord = async () => {
  
  const res = await CnyActApi.getLotteryRecord()
  console.log('getLotteryRecord res', res)
  return res.lotteryRecordList
}

const handleShowRecord = async () => {
  if (!store.state.cpUserInfo.token) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  
  const lotteryRecordList = await getLotteryRecord()
  const result = []
  lotteryRecordList.forEach(item => {
    const displayItem = globalConfig.displayList.find(displayItem => displayItem.lotteryRewardCode === item.lotteryRewardCode)
    result.push({
      ...displayItem,
      time: item.createTime,
    })
  })
  console.log('result', result)
  // const list = JSON.parse(JSON.stringify(LOTTERY_WHEEL_LIST))
  // list.forEach(item => {
  //   item.time = new Date().toLocaleString()
  // })
  toggleLotteryRecordDialog(true, { list: result }, () => {})
}

</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>

